import type { CheckOffer, OutflowOfferWebProps } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers.types';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { closeOverquotaWarningModal, openOverquotaWarningModal } from 'reactApp/ui/OverquotaWarningModal/OverquotaWarningModal';
import { select } from 'typed-redux-saga';

export function* checkOverquotaWarningOffer(_: CheckOffer) {
    const used = yield* select(UserQuotaSelectors.getUsed);

    const availableSpace = yield* select(UserQuotaSelectors.getTotalOrBase);
    const spaceLeft = availableSpace - _.subscription.space.original;

    return used?.total && used.total.original > spaceLeft;
}

export function* overquotaWarningOffer({ subscription, continueOutflow, cancelOutflow }: OutflowOfferWebProps) {
    yield openOverquotaWarningModal({
        subscription,
        onCancel() {
            closeOverquotaWarningModal();
            continueOutflow();
        },
        onClose() {
            closeOverquotaWarningModal();
            cancelOutflow();
        },
        onSuccess() {
            closeOverquotaWarningModal();
            cancelOutflow();
        },
    });
}
